import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/x-dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-383673a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%","object-fit":"cover","position":"absolute"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = { class: "sign-in-text" }
const _hoisted_5 = { class: "login-field" }
const _hoisted_6 = { class: "login-actions" }
const _hoisted_7 = { class: "login-btn" }
const _hoisted_8 = { style: {"height":"50px"} }
const _hoisted_9 = {
  key: 0,
  style: {"text-align":"center"},
  class: "login-error animated-fast"
}
const _hoisted_10 = {
  key: 0,
  class: "login-success animated-fast"
}
const _hoisted_11 = { class: "need-help" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("forgotPassword.recoverPassword")), 1),
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForgotPassword && _ctx.submitForgotPassword(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_imdex_text_field, {
            label: _ctx.$t(`forgotPassword.emailInputLabel`),
            value: _ctx.email,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            leadingIcon: "fa fa-envelope"
          }, null, 8, ["label", "value"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.success)
              ? (_openBlock(), _createBlock(_component_imdex_btn, {
                  key: 0,
                  type: "submit",
                  loading: _ctx.isLoading,
                  secondary: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("forgotPassword.resetPassword")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            (_ctx.success)
              ? (_openBlock(), _createBlock(_component_imdex_btn, {
                  key: 1,
                  type: "submit",
                  loading: _ctx.isLoading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/'))),
                  secondary: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("forgotPassword.backToLogin")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_Transition, {
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (_ctx.errorMessage != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (_ctx.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("forgotPassword.emailSent")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/')))
            }, [
              _hoisted_12,
              _createTextVNode("   " + _toDisplayString(_ctx.$t("forgotPassword.backToLogin")), 1)
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}